import createIcon from '../../createIcon';

/**
 * @component @name AspectRatio
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTJIMTdWMTVIMTRWMTdIMTlWMTJaTTcgOUgxMFY3SDVWMTJIN1Y5Wk0yMSAzSDNDMS45IDMgMSAzLjkgMSA1VjE5QzEgMjAuMSAxLjkgMjEgMyAyMUgyMUMyMi4xIDIxIDIzIDIwLjEgMjMgMTlWNUMyMyAzLjkgMjIuMSAzIDIxIDNaTTIxIDE5LjAxSDNWNC45OUgyMVYxOS4wMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AspectRatio = createIcon('AspectRatio', [
  [
    'path',
    {
      d: 'M19 12H17V15H14V17H19V12ZM7 9H10V7H5V12H7V9ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01Z',
      key: 'xi6kt8',
    },
  ],
]);

export default AspectRatio;
